/* eslint-disable jsx-a11y/heading-has-content */
/* eslint-disable jsx-a11y/img-redundant-alt */
// SliderComponent.js
import React from "react";

const Slider2 = () => {
  const sliderImages = [
    {
      desktop: "/assets/images/slider-1.webp",
      mobile: "/assets/images/slider-1-mobile.webp",
    },
    {
      desktop: "/assets/images/slider-2.webp",
      mobile: "/assets/images/slider-2-mobile.webp",
    },
    {
      desktop: "/assets/images/slider-3.webp",
      mobile: "/assets/images/slider-3-mobile.webp",
    },
  ];

  const renderSliderImage = (image, alt) => (
    <picture>
      <source media="(max-width: 767px)" srcSet={image.mobile} />
      <img src={image.desktop} alt={alt} />
    </picture>
  );

  return (
    <section id="section-1">
    <div class="content-slider">
      <input type="radio" id="banner1" class="sec-1-input" name="banner" checked/>
      <input type="radio" id="banner2" class="sec-1-input" name="banner"/>
      <input type="radio" id="banner3" class="sec-1-input" name="banner"/>
      <div class="slider">
        <div id="top-banner-1" class="banner">
          <div class="banner-inner-wrapper header-text">
            {renderSliderImage(sliderImages[0], "Slider 1")}
            {/*<div class="main-caption">
              <h2>Aven Mobilya Güvencesiyle</h2>
              <h1>Koltuk Takımı</h1>
              <div class="border-button"><a href="about.html">Keşfedin</a></div>
            </div>
             <div class="container">
              <div class="row">
                <div class="col-lg-12">
                  <div class="more-info">
                    <div class="row">
                      <div class="col-lg-3 col-sm-6 col-6">
                        <i class="fa fa-user"></i>
                        <h4><span>Population:</span><br/>44.48 M</h4>
                      </div>
                      <div class="col-lg-3 col-sm-6 col-6">
                        <i class="fa fa-globe"></i>
                        <h4><span>Territory:</span><br/>275.400 KM<em>2</em></h4>
                      </div>
                      <div class="col-lg-3 col-sm-6 col-6">
                        <i class="fa fa-home"></i>
                        <h4><span>AVG Price:</span><br/>$946.000</h4>
                      </div>
                      <div class="col-lg-3 col-sm-6 col-6">
                        <div class="main-button">
                          <a href="about.html">Explore More</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
        <div id="top-banner-2" class="banner">
          <div class="banner-inner-wrapper header-text">
            {renderSliderImage(sliderImages[1], "Slider 2")}
          </div>
        </div>
        <div id="top-banner-3" class="banner">
          <div class="banner-inner-wrapper header-text">
            {renderSliderImage(sliderImages[2], "Slider 3")}
            {/*<div class="main-caption">
              <h2>Aven Mobilya Güvencesiyle</h2>
              <h1>Yatak Odası</h1>
              <div class="border-button"><a href="about.html">Keşfedin</a></div>
            </div>
             <div class="container">
              <div class="row">
                <div class="col-lg-12">
                  <div class="more-info">
                    <div class="row">
                      <div class="col-lg-3 col-sm-6 col-6">
                        <i class="fa fa-user"></i>
                        <h4><span>Population:</span><br/>67.41 M</h4>
                      </div>
                      <div class="col-lg-3 col-sm-6 col-6">
                        <i class="fa fa-globe"></i>
                        <h4><span>Territory:</span><br/>551.500 KM<em>2</em></h4>
                      </div>
                      <div class="col-lg-3 col-sm-6 col-6">
                        <i class="fa fa-home"></i>
                        <h4><span>AVG Price:</span><br/>$425.600</h4>
                      </div>
                      <div class="col-lg-3 col-sm-6 col-6">
                        <div class="main-button">
                          <a href="about.html">Explore More</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>

      </div>
      <nav>
        <div class="controls">
          <label for="banner1"><span class="progressbar"><span class="progressbar-fill"></span></span></label>
          <label for="banner2"><span class="progressbar"><span class="progressbar-fill"></span></span></label>
          <label for="banner3"><span class="progressbar"><span class="progressbar-fill"></span></span></label>
        </div>
      </nav>
    </div>
  </section>
  );
};

export default Slider2;
